<h1 class="d_subtitulo">Lo más reciente</h1>

<div class="d_principalin">
    <p-carousel [value]="list_app" [numVisible]="3" [numScroll]="3" [circular]="true" autoplayInterval="0"
        [responsiveOptions]="responsiveOptions">

        <ng-template let-app #item>
            <div class="d_galeria_actividades" (click)="onOpenApp(app.id)"
            (mouseenter)="showShareButton(app.id, app)"
            (mouseleave)="hideShareButton(app.id)">
                <div class="d_galeria_actividadesconte d_galeriacarrouselconte">
                    <img [src]="url_img_app + app.prefijo + '.png'" />
                    <span class="d_galeria_categos">
                        <!--ICONOS DE CATEGORIAS-->
                        <img src="assets/redi/icons/categorias/{{ app.categoria.toLocaleLowerCase() | removeAccents  }}.svg" />
                    </span>
                    <div class="sharetoclassroom" id="gshare-{{app.id}}"></div>
                </div>
                <p class="galeria__texto">{{app.label}}</p>
            </div>
        </ng-template>
    </p-carousel>
</div>
<!-- <div class="d_principalin">

    <div class="d_galeria_actividades">
        <img src="assets/redi/img/actividad_naranja.png" />
        <p class="galeria__texto">Lideres y conservadores</p>
    </div>
    <div class="d_galeria_actividades">
        <img src="assets/redi/img/actividad_morado.png" />
        <p class="galeria__texto">Lideres y conservadores</p>
    </div>
    <div class="d_galeria_actividades">
        <img src="assets/redi/img/actividad_morado.png" />
        <p class="galeria__texto">Lideres y conservadores</p>
    </div>
</div> -->
<!-- Aquí están los botones del carrusel -->
<!-- <div class="d_btns_actividades">
    <div class="d_principalin">
        <div class="d_carouselbts2">
            <label class="d_carouselbtn"></label>
            <label class="d_carouselbtn"></label>
            <label class="d_carouselbtn"></label>
        </div>

    </div>
</div> -->
